'use client';

/**
 * FormSubmitButton (storefront, live) — submits the surrounding form and
 * OWNS the after-submit behavior: publishes successMessage /
 * successRedirectUrl into FormContext.successRef (read by the form owner on
 * successful submission). While submitting: disabled + label swap.
 * Falls back to the shared preview outside a FormContainer.
 */

import React, { useEffect } from 'react';
import { FormSubmitButton as Shared } from '@launchstore/shared-puck';
import type { FormSubmitButtonProps } from '@launchstore/shared-puck';
import { resolveColor } from '@launchstore/shared-puck';
import { useFormContext } from './FormContext';

function FormSubmitButtonLive(props: FormSubmitButtonProps) {
  const ctx = useFormContext();

  // Publish the after-submit behavior to the form owner.
  useEffect(() => {
    if (ctx?.successRef) {
      ctx.successRef.current = {
        successMessage: props.successMessage || 'Thank you! Your submission has been received.',
        successRedirectUrl: props.successRedirectUrl || '',
      };
    }
  }, [props.successMessage, props.successRedirectUrl, ctx?.successRef]);

  if (!ctx) return <>{(Shared.render as any)(props)}</>;
  const { isSubmitting } = ctx;

  const hoverCss = `.form-submit-live-btn:hover { background-color: ${resolveColor(props.hoverBackgroundColor)} !important; }`;

  return (
    <div className={`mt-${props.marginTop || '2'} ${props.fullWidth ? 'w-full' : 'inline-block'}`}>
      <style dangerouslySetInnerHTML={{ __html: hoverCss }} />
      <button
        type="submit"
        disabled={isSubmitting}
        className={[
          'form-submit-live-btn transition-all duration-200 disabled:opacity-60',
          `text-${props.fontSize} font-${props.fontWeight}`,
          `px-${props.paddingX} py-${props.paddingY}`,
          `rounded-${props.borderRadius} shadow-${props.shadow}`,
          props.fullWidth ? 'w-full' : '',
        ].filter(Boolean).join(' ')}
        style={{ backgroundColor: resolveColor(props.backgroundColor), color: resolveColor(props.textColor) }}
      >
        {isSubmitting ? 'Submitting…' : props.buttonText}
      </button>
    </div>
  );
}

export const FormSubmitButton: any = {
  ...Shared,
  render: (props: any) => <FormSubmitButtonLive {...props} />,
};

export default FormSubmitButton;
